import { Controller } from "@hotwired/stimulus"

// IdeaProgetto.js, «Il progetto» del passo 2: aperto o chiuso (aperta), le categorie e i tipi accesi (toggle), il filtro
// delle categorie (cerca), il testo preso dalla descrizione del progetto (idea-da-descrizione finché il testo è quello)
// e l'avviso delle spese già sostenute. Una vista alla volta: con un'idea salvata il modulo sta in un <template> (target
// `modulo`) e «Modifica» lo mette al posto del riquadro chiuso; «Annulla» rimette il riquadro e la prossima apertura
// riparte dai valori salvati (daSalvata: il testo salvato, non quello della descrizione). «Salva» invia il modulo
// (PUT /app/progetto/:id/idea); le categorie e i tipi accesi sono i campi nascosti del target `campi`. Invio in un campo
// non salva (l'originale non aveva un modulo). Sul contenitore della pagina: i target si ricollegano quando una scrittura
// riscrive la pagina.
const ACCESA = ["bg-zinc-900", "text-white", "border-zinc-900"]
const SPENTA = ["bg-white", "text-zinc-600", "border-zinc-300"]

export default class extends Controller {
  static targets = ["chiusa", "aperta", "modulo", "testo", "daDescrizione", "cerca", "scelta", "campi", "avvisoSpese"]

  apri() {
    if (!this.hasChiusaTarget || !this.hasModuloTarget) return
    const modello = this.moduloTarget
    const form = modello.content.querySelector("form").cloneNode(true)
    const chiusa = this.chiusaTarget
    chiusa.replaceWith(form)
    form.chiusa = chiusa
    // i target del modulo appena inserito: Stimulus li collega dopo, qui si leggono dal modulo stesso
    const testo = form.querySelector("[data-idea-progetto-target~='testo']")
    if (modello.dataset.annullata === "true") testo.value = form.dataset.testoSalvato || ""
    const cerca = form.querySelector("[data-idea-progetto-target~='cerca']")
    if (cerca) cerca.value = modello.dataset.cerca || ""
    this.filtra({ form })
    this.segna({ form })
  }

  annulla() {
    const form = this.apertaTarget
    if (this.hasModuloTarget) {
      this.moduloTarget.dataset.annullata = "true"
      this.moduloTarget.dataset.cerca = this.hasCercaTarget ? this.cercaTarget.value : ""
    }
    if (form.chiusa) form.replaceWith(form.chiusa)
  }

  nonInviare(event) {
    if (event.target.tagName === "INPUT") event.preventDefault()
  }

  scegli(event) {
    const b = event.currentTarget
    this.accendi(b, b.dataset.scelta !== "true")
    this.scriviCampi()
  }

  accendi(b, on) {
    b.dataset.scelta = on ? "true" : "false"
    b.classList.remove(...(on ? SPENTA : ACCESA))
    b.classList.add(...(on ? ACCESA : SPENTA))
  }

  scriviCampi() {
    this.campiTarget.replaceChildren(...this.sceltaTargets.filter((b) => b.dataset.scelta === "true").map((b) => {
      const i = document.createElement("input")
      i.type = "hidden"
      i.name = `${b.dataset.campo}[]`
      i.value = b.dataset.valore
      return i
    }))
  }

  filtra(opzioni = {}) {
    const form = opzioni.form || this.apertaTarget
    const cerca = form.querySelector("[data-idea-progetto-target~='cerca']")
    const q = cerca ? cerca.value.toLowerCase() : ""
    for (const b of form.querySelectorAll("[data-idea-progetto-target~='scelta']")) {
      if (b.dataset.campo === "categorie") b.hidden = !!q && !b.dataset.label.toLowerCase().includes(q)
    }
  }

  segna(opzioni = {}) {
    const form = opzioni.form || this.apertaTarget
    const marca = form.querySelector("[data-idea-progetto-target~='daDescrizione']")
    if (!marca) return
    const partenza = form.dataset.partenza || ""
    marca.hidden = !(partenza && form.querySelector("[data-idea-progetto-target~='testo']").value === partenza)
  }

  sostenute() {
    const si = this.apertaTarget.querySelector('input[name="spese_sostenute"][value="true"]')
    this.avvisoSpeseTarget.hidden = !(si && si.checked)
  }
}
